import { BrowserCacheLocation, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { MsalConfigDto } from '@interfaces/MsalConfigDto';
import { NGXLogger } from 'ngx-logger';

export class MsalConfig {

  public static createInstance(config: MsalConfigDto, logger: NGXLogger) {
    return new PublicClientApplication({
      auth: {
        clientId: config.clientId,
        authority: `${config.provider}/${config.tenantId}`,
        redirectUri: '/', // Must register this URI on Azure portal/App Registration.
        navigateToLoginRequestUrl: false
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        loggerOptions: {
          logLevel: LogLevel.Warning,
          loggerCallback: (level: LogLevel, message: string) => MsalConfig.loggerCallbackMsal(logger, level, message),
          piiLoggingEnabled: false // If set to true, logs personal and organizational data
        }
      }
    });
  }

  private static _preferred: InteractionType.Redirect | InteractionType.Popup = InteractionType.Redirect;

  public static get PreferredInteractionType() {
    return this._preferred;
  }
  public static set PreferredInteractionType(value: InteractionType.Redirect | InteractionType.Popup) {
    this._preferred = value;
  }

  public static loggerCallbackMsal(logger, level: LogLevel, message: string) {
    switch (level) {
      case LogLevel.Error:
        logger.error(message);
        return;
      case LogLevel.Info:
        logger.info(message);
        return;
      case LogLevel.Verbose:
        logger.debug(message);
        return;
      case LogLevel.Warning:
        logger.warn(message);
        return;
    }
  }
}
